import matches from 'lodash/matches';
import { all, put, take, takeEvery } from 'redux-saga/effects';

import { executeSagaRequest } from '@savgroup-front-common/core/services';
import * as ActionCreators from '@savgroup-front-common/core/domains/workflow/actionCreators';
import { getFileActions } from '@savgroup-front-common/core/domains/workflow/actionCreators';
import * as ActionTypes from '@savgroup-front-common/core/domains/workflow/actionTypes';

import { addFileCommentRequest } from '../../../api/Workflow/files/addFileCommentCommand';
import { deleteFileCommentRequest } from '../../../api/Workflow/files/deleteFileCommentCommand';
import { getCustomerFileFullSummaryRequest } from '../../../api/Workflow/files/getCustomerFileFullSummaryQuery';
import { getFileCommentListRequest } from '../../../api/Workflow/files/getFileCommentListQuery';
import { updateFileCommentRequest } from '../../../api/Workflow/files/updateFileCommentCommand';

import { GET_FILE_FULL_SUMMARY, getFullFileSummary, types } from './actions';

function* getFileFullSummaryWorker({ payload: fileId }) {
  const meta = { fileId };

  if (!fileId) {
    yield put(GET_FILE_FULL_SUMMARY.end(meta));

    return;
  }

  yield executeSagaRequest(
    GET_FILE_FULL_SUMMARY,
    getCustomerFileFullSummaryRequest({ fileId }),
    meta,
  );
  yield put(GET_FILE_FULL_SUMMARY.end(meta));
}
export function* getFileFullSummaryWatcher() {
  yield takeEvery(GET_FILE_FULL_SUMMARY.BASE, getFileFullSummaryWorker);
}

function* getFileCommentsWorker({ payload: fileId }) {
  const meta = { fileId };

  yield executeSagaRequest(
    types.GET_FILE_COMMENTS,
    getFileCommentListRequest({ fileId }),
    meta,
  );
  yield put(types.GET_FILE_COMMENTS.end(meta));
}
export function* getFileCommentsWatcher() {
  yield takeEvery(GET_FILE_FULL_SUMMARY.BASE, getFileCommentsWorker);
}

function* sendNewFileCommentWorker({ payload: { fileId, newComment } }) {
  const meta = { fileId, indexer: newComment.internalId, newComment };

  yield executeSagaRequest(
    types.SEND_NEW_FILE_COMMENTS,
    addFileCommentRequest({ fileId, content: newComment.content }),
    meta,
  );

  yield put(types.SEND_NEW_FILE_COMMENTS.end(meta));
}
export function* sendNewFileCommentWatcher() {
  yield takeEvery(types.SEND_NEW_FILE_COMMENTS.BASE, sendNewFileCommentWorker);
}

function* updateFileCommentWorker({ payload: { fileId, newComment } }) {
  const meta = { fileId, indexer: newComment.internalId, newComment };

  yield executeSagaRequest(
    types.UPDATE_FILE_COMMENTS,
    updateFileCommentRequest({
      fileCommentId: newComment.id,
      NewContent: newComment.content,
    }),
    meta,
  );

  yield put(types.UPDATE_FILE_COMMENTS.end(meta));
}
export function* updateFileCommentWatcher() {
  yield takeEvery(types.UPDATE_FILE_COMMENTS.BASE, updateFileCommentWorker);
}

function* deleteFileCommentWorker({ payload: { fileId, comment } }) {
  const meta = { fileId, indexer: comment.internalId };

  yield executeSagaRequest(
    types.DELETE_FILE_COMMENTS,
    deleteFileCommentRequest({ fileCommentId: comment.id }),
    meta,
  );

  yield put(types.DELETE_FILE_COMMENTS.end(meta));
}
export function* deleteFileCommentWatcher() {
  yield takeEvery(types.DELETE_FILE_COMMENTS.BASE, deleteFileCommentWorker);
}

function* setUserActionAndHydrateFileSummaryWorker({
  payload: { fileId, module, fromState, toState, comment, toCustomerComment },
}) {
  yield all([
    put(
      ActionCreators.setSyncUserAction({
        fileId,
        module,
        fromState,
        toState,
        comment,
        toCustomerComment,
      }),
    ),
    take(
      matches({
        type: ActionTypes.SET_SYNC_USER_ACTION.END,
        meta: fileId,
      }),
    ),
  ]);

  yield all([
    put(getFileActions(fileId)),
    put(getFullFileSummary(fileId)),
    take(
      matches({
        type: GET_FILE_FULL_SUMMARY.END,
        meta: {
          fileId,
        },
      }),
    ),
  ]);
}

function* setUserActionAndHydrateFileSummaryWatcher() {
  yield takeEvery(
    ActionTypes.SET_USER_ACTION_AND_HYDRATE_FILE_SUMMARY.BASE,
    setUserActionAndHydrateFileSummaryWorker,
  );
}

export default function* workflowFileSummarySaga() {
  yield all([
    getFileFullSummaryWatcher(),
    getFileCommentsWatcher(),
    sendNewFileCommentWatcher(),
    updateFileCommentWatcher(),
    deleteFileCommentWatcher(),
    setUserActionAndHydrateFileSummaryWatcher(),
  ]);
}
